import { IActivityHistoryItem } from "../domain/model";

export const removeItemFromCollection = (
  collections: Record<string, any>,
  id: string,
  itemId: string,
) => {
  if (!collections[id]?.items) return collections;
  const items = collections[id]?.items ?? [];

  return {
    ...collections,
    [id]: {
      ...collections[id],
      items: items.filter((i: IActivityHistoryItem) => i.id !== itemId),
    },
  };
};